import { useQuery } from "@tanstack/react-query";
import { createRoute } from "@tanstack/react-router";
import {
  JsonEditsTable,
  JsonEditsTableSkeleton,
} from "@/components/case/json-edits-table";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { caseLayoutRoute } from "./case-layout-route";

export const caseJsonEditsRoute = createRoute({
  getParentRoute: () => caseLayoutRoute,
  path: "/json-edits",
  component: CaseJsonEditsPage,
});

function CaseJsonEditsPage() {
  const { caseId } = caseJsonEditsRoute.useParams();
  const auth = useAuth();
  const logsQuery = useQuery({
    queryKey: ["json-edits", caseId],
    queryFn: () => api.listJsonEdits(caseId),
    enabled: auth.status === "authed" && Boolean(caseId),
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="font-heading text-base font-medium">修改记录</h2>
        <p className="text-sm text-muted-foreground">
          人手在编辑器里保存 Phone JSON 后记下这次改了哪些字段。流水线生成不记。
        </p>
      </div>
      {logsQuery.isLoading ? <JsonEditsTableSkeleton /> : null}
      {logsQuery.isError ? (
        <p className="text-sm text-destructive" role="alert">
          无法加载修改记录，请刷新重试。
        </p>
      ) : null}
      {logsQuery.isSuccess ? (
        <JsonEditsTable logs={logsQuery.data.logs} />
      ) : null}
    </div>
  );
}
